fragment ShippingAddressFragment on ShippingAddress {
    id
    firstName
    lastName
    company
    email
    address
    address2
    city
    zip
    country
    country_name
    state
    phone
}